import { Component } from "react";
import PropTypes from "prop-types";
import GlobalContext from "components/stores/global-context";
import openOverlay from "components/helpers/open-overlay";

export default class OverlayLink extends Component {
  static propTypes = {
    to: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    state: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    event.preventDefault();

    openOverlay(this.props.to, this.props.state, this.context);
  }

  render() {
    return (
      <a className={this.props.className} href={this.props.to} onClick={this.onClick}>
        {this.props.children}
      </a>
    );
  }
}

OverlayLink.contextType = GlobalContext;

export { openOverlay };
